import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageEditText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageEditText"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H20V11.8779C18.4159 11.4054 16.6296 11.7946 15.3787 13.0455L11 17.4242V22H4ZM8 6.25H16V8.25H8V6.25ZM8 10.25V12.25H12V10.25H8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M16.7929 14.4597C17.8278 13.4249 19.5056 13.4249 20.5404 14.4597C21.5753 15.4946 21.5753 17.1724 20.5404 18.2073L16.7475 22.0002H13V18.2526L16.7929 14.4597Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageEditText;
